import './EditableImagePreviewHeader.scss';
import { useTranslator } from '@Localization';
import { observer } from 'mobx-react-lite';
import { ReactElement, useState } from 'react';
import { IPermissionCheckResult } from '../../../../modules/permissions/permissionsHelpers';
import { ValidatedTextInput } from '../../../components/ValidatedTextInput';
import { MAX_FILE_NAME_LENGTH } from '../../../helpers/global.constants';
import { InputStatus } from '../../../models/error.model';
import { AnnotationImageNameHeader } from '../../annotation/components/AnnotationImageNameHeader';
import { DatasetStatus } from '../datasetStatus.model';

interface IProps {
  canRenameImages: IPermissionCheckResult;
  name: string;
  nameStatus: InputStatus;
  newName: string;
  datasetName?: string;
  datasetStatus?: DatasetStatus;
  onCancelRenameImage: () => void;
  onImageNameBlur: () => Promise<void>;
  onImageNameChange: (imageName: string) => void;
  onStartEdit: () => void;
}

export const EditableImagePreviewHeader = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const [renderInput, setRendeInput] = useState(false);

  const containerClassName = `image-name-wrapped ${props.canRenameImages.allowed ? 'hover-highlight' : ''}`;
  const showWarning = props.datasetStatus !== undefined && props.datasetStatus !== 'Published' && props.datasetStatus !== 'PublishedUploading';

  const openRenameInput = (): void => {
    if (props.canRenameImages.allowed) {
      props.onStartEdit();
      setRendeInput(true);
    }
  };

  const closeRenameInput = (): void => {
    setRendeInput(false);
  };

  const onImageNameBlur = async (): Promise<void> => {
    await props.onImageNameBlur();

    if (props.nameStatus.isEmpty) {
      closeRenameInput();
    }
  };

  const onCancelRenameImage = (): void => {
    props.onCancelRenameImage();
    closeRenameInput();
  };

  return (
    <>
      {renderInput ? (
        <ValidatedTextInput
          id='rename-image'
          type='text'
          maxLength={MAX_FILE_NAME_LENGTH}
          value={props.newName}
          placeholder={t('type_image_name_here')}
          onChange={props.onImageNameChange}
          onBlur={() => {
            void onImageNameBlur();
          }}
          className='input_click_editable image-preview-name'
          isValid={props.nameStatus.isValid}
          feedbacks={props.nameStatus.errorCodes}
          autofocus
          onPressEnter={() => {
            void onImageNameBlur();
          }}
          onPressEscape={onCancelRenameImage}
        />
      ) : (
        <div
          className={containerClassName}
          onClick={openRenameInput}
        >
          <AnnotationImageNameHeader
            imageName={props.name}
            datasetName={props.datasetName}
            showWarning={showWarning}
            warningTooltip={t('unpublished')}
            isLoading={false}
          />
        </div>
      )}
    </>
  );
});
